const SettingsEnum = {
    DefaultCaseDays : "განაცხადის დღეები",
    SendMailForUserRegistration:  "მომხმარებლის რეგისტრაციისას მეილის გააქტიურება",
    SendUpdateMailToRole: "სიახლეზე მეილის გაგზავნა როლის მიხედვით",
    DefaultCaseRejectionDays: "დახარვეზების დღეები",
    SeeGetAllCasePublic: "განაცხადების დამალვა",
    GetPhisicalPersonInfo: "ფიზკური პირის ვალიდაცია",
    GetSubjByIdNrQuery: "იურიდიული პირის ვალიდაცია",
    AddNewCase: "განაცხადის რეგისტრაციის ვალიდაცია",
    AddCaseFile: "ფაილების ზომის ვალიდაცია",
    Login: "ავტორიზაცია",
}

export default SettingsEnum